<template>
  <div class="foot">
    <div class="wrap">
      <div class="section">
        <div class="sponsors">
          <p>Projekt izvaja</p>
          <ul>
            <li>
              <a title="SODO" href="https://www.sodo.si/" target="_blank">
                <img
                  id="ctl00_Image2"
                  src="../assets/images/sodo.png"
                  alt="sponsors"
                  style="border-width:0px;"
                />
              </a>
            </li>
          </ul>
        </div>
        <div class="contact">
          <a href="mailto:sodo@sodo.si"></a>
        </div>
      </div>
      <div class="section"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Foot',
  props: {},
};
</script>

<style>
</style>